export const SIDEBAR_WIDTH_PX = 200;
export const SIDEBAR_COLLAPSED_WIDTH_PX = 56;
/** Logo block height – keep when collapsed so nav icons stay vertically aligned. */
export const SIDEBAR_LOGO_AREA_HEIGHT_PX = 80;
/** Top offset of nav links below the logo (see styles.css nav.ms-Nav). */
export const SIDEBAR_NAV_PADDING_TOP_PX = 60;

export function getSidebarWidth(collapsed) {
  return collapsed ? SIDEBAR_COLLAPSED_WIDTH_PX : SIDEBAR_WIDTH_PX;
}
